import { ChangeEvent, ChangeEventHandler, useCallback } from 'react';
import BaseNode, { NodeInput, NodeOutput, contentStyle as style } from "./base-nodes/BaseNode";
import NodeStore from '../../stores/NodeStore';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Connection, Handle, Position } from 'reactflow';
import { Data } from './base-nodes/InputOutputNode';
import useDesigner from '../../hooks/useDesigner';
import { optionNode } from '../../config/node-types';

type Props = {
    data: {
        value: string
    },
    isConnectable: boolean,
    id: string
}

const config = {
    name: 'Option',
    color: "green",
    nodeType: 'optionNode',
    inputs: [
        { ...optionNode, inputColor: 'green' },
        /*{ ...questionNode, inputColor: 'green' },        */
        //{
        //    label: 'Yes/No',
        //    type: 'YesNoNode'
        //},        
        //    {
        //        label: 'Information',
        //        type: 'informationNode'
        //    },
        //    {
        //        label: 'Input',
        //        type: 'inputNode'
        //    },
    ],
    outputs: [
        //{ ...questionNode, outputColor: '#0000CD' },
        //{ ...imageNode, outputColor: 'Magenta' },
        //{ ...emailNode, outputColor: '#43C6DB' },
        //promptNode
        //{
        //    label: 'Information',
        //    type: 'informationNode'
        //},
        //{
        //    label: 'Input',
        //    type: 'inputNode'
        //},
        //    {
        //        label: 'Yes/No',
        //        type: 'YesNoNode'
        //    }
    ]
} as Data

function OptionNode({ data, isConnectable, id }: Props) {
    const { nodes } = useDesigner();

    const onChange = useCallback((evt: ChangeEvent<HTMLTextAreaElement>) => {
        NodeStore.update((s, o) => {
            const temp = structuredClone(o.chat);

            const node = temp.nodes.find(s => s.id === id);

            if (node) {
                node.data.value = evt.target.value;
            }
            localStorage.setItem('nodes', JSON.stringify(temp));
            s.chat = temp;
            s.isDirty = true;
        });
    }, []);

    return (
        <BaseNode
            label={config.name}
            selected={false}
            color={config.color}
            content={
                <>
                    <div className='main' style={{ display: 'flex', flexDirection: 'column' }}>
                        <textarea placeholder='Option' rows={1} cols={30} name="text" onChange={onChange} className="nodrag" value={data.value} style={{ border: '1px solid lightgray;', borderRadius: 5, margin: 5, fontSize: 16, fontFamily: 'sans-serif', minWidth: 200, padding: 2 }} />
                    </div>

                    <div
                        style={{ ...style.io }}
                    >

                        <Handle
                            type="source"
                            position={Position.Right}
                            id={'src_playNode'}
                            style={{ ...style.nextHandle, backgroundColor: 'white', ...style.right, }}
                            isValidConnection={(connection: Connection) => {
                                const destNode = nodes.find(s => s.id === connection.source);

                                if (!destNode) return false;

                                return connection.sourceHandle === "src_playNode" && connection.targetHandle === "inp_playNode";
                            }}
                        >
                            <PlayArrowIcon style={{ fontSize: 18, pointerEvents: 'none' }} />
                        </Handle>
                    </div>

                    {config.inputs.map((output: NodeInput) => (
                        <div
                            key={"o-" + output.label}
                            style={{ ...style.io, ...style.textLeft }}
                        >
                            {output.label}
                            <Handle
                                type="target"
                                position={Position.Left}
                                id={'inp_' + output.type}
                                style={{ ...style.handle, backgroundColor: output.inputColor }}
                                isValidConnection={(connection) => {
                                    const destNode = nodes.find(s => s.id === connection.target);

                                    if (!destNode) return false;

                                    return true;
                                }}
                            />
                        </div>
                    ))}
                </>
            }
        />
    );
}

export default OptionNode;